import Vue from 'vue'
import Vuex from 'vuex'
// import app from './modules/app'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
// import user from './modules/user'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    // app,
    permission,
    tagsView,
    // user
  },
  state:{
    Authorization:localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : ''
  },
  mutations: {
      // 修改token，并将token存入localStorage
      setToken(state,value){
           state.Authorization = value;
           sessionStorage.setItem('Authorization',value)
      }
      // changeLogin (state, user) {
      //   state.Authorization = user.Authorization;
      //   localStorage.setItem('Authorization', user.Authorization);
      // }
    },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js